import { useContext } from 'react'

import { CONFIG_ENABLE_ZIP } from '@src/config/env'

import ZipCodeContext from '../context/zipcode.context'

export function useZipCode() {
  const { zipCode, updateZipCode } = useContext(ZipCodeContext)

  if (CONFIG_ENABLE_ZIP) {
    return { zipCode, updateZipCode }
  }
  return {
    zipCode: undefined,
    updateZipCode,
  }
}

export function useZipCodeEditModal() {
  const { isZipcodeModalOpen, openZipcodeModal } = useContext(ZipCodeContext)
  return { isZipcodeModalOpen, openZipcodeModal }
}
